import { FormLabel, GridItem, Select } from "@chakra-ui/react";
import React, { useMemo, useState } from "react";
import useQuote from "../../hooks/useQuote";
import useUser from "../../hooks/useUser";
import { SelectItem } from "../../lib/types/SelectItem";
import { elevatedUsers } from "../../lib/UserPermissions";
import SelectField from "../form-fields/SelectField";
import ExceptionSubmitButton from "./ExceptionSubmitButton";

export type ExceptionOptionsProps = {
  handler: (status: string | undefined) => void;
};

function ExceptionOptions({ handler }: ExceptionOptionsProps) {
  const { state } = useQuote();
  const { metadata } = state;
  const { role } = useUser();
  const [selectedValue, setSelectedValue] = useState(
    metadata?.exceptionStatus ?? ""
  );

  const selectExceptionStatus = useMemo(
    () => [
      { label: "Requested to Sales Manager", value: "Requested" },
      {
        label: "Submitted to Capital Markets",
        value: "Submitted",
        disabled:
          role !== "Production Coordinator" &&
          role !== "Operations Analyst" &&
          role !== "POD" &&
          role !== null &&
          !elevatedUsers.includes(role),
      },
      {
        label: "Not Approved",
        value: "Not Approved",
        disabled: role !== "Administrator" && role !== "Capital Markets",
      },
      {
        label: "Approved",
        value: "Approved",
        disabled: role !== "Administrator" && role !== "Capital Markets",
      },
    ],
    [role]
  );

  return (
    <>
      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <SelectField
          label="Select Exception Type"
          name="exceptionType"
          placeholder="None"
          data={selectExceptionType}
        />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <FormLabel>Select Exception Status</FormLabel>
        <Select
          placeholder="None"
          value={selectedValue}
          onChange={(e: any) => {
            setSelectedValue(e.target.value);
          }}
        >
          {selectExceptionStatus.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </Select>
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 12 }}></GridItem>

      <GridItem colSpan={{ base: 12, lg: 12 }} marginLeft={{ base: 0, lg: 12 }}>
        <ExceptionSubmitButton
          contentText={
            "Once an exception is submitted this action cannot be reverted."
          }
          status={selectedValue}
          handler={handler}
        />
      </GridItem>
    </>
  );
}

export default ExceptionOptions;

export const selectExceptionType: SelectItem[] = [
  { label: "Credit", value: "Credit" },
  { label: "Pricing", value: "Pricing" },
  // { label: "Leverage", value: "Leverage" },
];
